﻿import React, { useEffect, useState, useRef } from 'react';
import { StrikeThroughHeader } from '../../../../components/Headers/strikethrough-header/strikethrough-header';
import { GetISDCategoryList, GetISDMarketingList, EmailForm } from '../../../../api/admin';
import { useQuery, useMutation } from '@tanstack/react-query';

import { Card } from 'Components/Cards/card/card';
import { Link } from 'react-router-dom';
import LoadingIndicator from 'Components/Global/loading-indicator/loading-indicator';
import SharepointLink from 'Components/Global/SharepointLink/SharepointLink';
import { XMasonry, XBlock } from 'react-xmasonry';
//import PreviewIcon from '@mui/icons-material/Preview';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
//import FileUploadIcon from '@mui/icons-material/FileUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import EmailIcon from '@mui/icons-material/Email';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useUser } from '../../../../context/UserContext';
import useForm from '../../../AdminContentMgt/Components/useForm';

import { EmailMaskedTextField } from '../../../../components/Inputs/TextFields/MaskedTextFields/EmailMaskedTextField/EmailMaskedTextField';

export default function ISDMarketingEmailModule({ ...props }) {
  const emailRowStyle = {
    margin: '1em 2em',
  };

  const user = useUser();
  const textRef = useRef();
  const [validEmail, setValidEmail] = useState(false);
  const [errorText, setErrorText] = useState('');

  const [senderEmail, setSenderEmail] = useState(user.emailAddress);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [emailRecipient, setEmailRecipient] = useState('');
  const emailFormMutation = useMutation({
    mutationFn: (data) => EmailForm(data)(),
    onSuccess: (sent) => {
      HideEmailModal();
      // Set after hiding: HideEmailModuleCallback resets status/notif in the parent.
      props.setStatus(sent === true ? 'success' : 'error');
      props.setShowNotif(true);
    },
    onError: () => {
      HideEmailModal();
      props.setStatus('error');
      props.setShowNotif(true);
    },
  });

  function HideEmailModal() {
    props.HideEmailModuleCallback();

    handleDataChange('subject', '');
    handleDataChange('body', '');
    handleDataChange('emails', '');
    handleDataChange('cc', '');
  }

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ('subject' in fieldValues)
      temp.subject = fieldValues.subject ? '' : 'Message Subject is a required field.';
    if ('body' in fieldValues)
      temp.body = fieldValues.body ? '' : 'Message Body is a required field.';
    if ('emails' in fieldValues)
      temp.emails = fieldValues.emails ? '' : 'Emails are a required field.';

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == '');
  };

  function GetBody() {
    let tmpBody = '';

    //check for link attachments
    for (let i = 0; i < props.attachedLinks.length; i++) {
      tmpBody += props.attachedLinks[i].linkToResource + '                ';
    }

    return tmpBody;
  }

  const {
    values,
    errors,
    setErrors,
    handleInputChange,
    handleIntChange,
    handleImageChange,
    handleDataChange,
  } = useForm(
    {
      subject: subject,
      body: GetBody(),
      senderEmail: user.emailAddress,
      emails: '',
      cc: '',
    },
    true,
    validate
  );

  function GetFormAttachments() {
    let tmpAttachments = '';

    for (var i = 0; i < props.attachedForms.length; i++) {
      var form = props.attachedForms[i];

      if (props.attachedForms.length > 1)
        tmpAttachments += form.id + '^' + form.linkToResource + ',';
      else tmpAttachments += form.id + '^' + form.linkToResource;
    }

    if (props.attachedForms.length > 1)
      tmpAttachments = tmpAttachments.substring(0, tmpAttachments.length - 1);

    return tmpAttachments;
  }

  useEffect(() => {
    // Only clear a stale notification when the modal opens; clearing on close would
    // wipe the result snackbar the mutation just raised.
    if (props.showEmailModal) props.setShowNotif(false);
  }, [props.showEmailModal]);

  useEffect(() => {
    handleDataChange('body', GetBody());
  }, [props.attachedLinks]);

  return (
    <>
      <Dialog
        open={props.showEmailModal}
        onClose={(_event, reason) => {
          if (reason !== 'backdropClick') HideEmailModal();
        }}
        PaperProps={{ sx: { height: '100vh', overflow: 'auto', width: '100%' } }}
      >
        <DialogTitle>
          Send Email
          <IconButton onClick={HideEmailModal} style={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {emailFormMutation.isPending ? (
          <DialogContent>
            <LoadingIndicator />
          </DialogContent>
        ) : (
          <>
            <DialogContent id="email-form-modal-body">
              <div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">
                    <TextField
                      variant="outlined"
                      fullWidth={true}
                      label="From:"
                      name="message-from"
                      value={values.senderEmail}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">
                    <TextField
                      variant="outlined"
                      fullWidth={true}
                      label="Send To:"
                      name="message-sendto"
                      value={values.emails}
                      error={!!errors.emails}
                      helperText={errors.emails}
                      onChange={(e) => {
                        handleDataChange('emails', e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">
                    <TextField
                      variant="outlined"
                      fullWidth={true}
                      label="CC:"
                      name="message-cc"
                      value={values.cc}
                      error={!!errors.cc}
                      helperText={errors.cc}
                      onChange={(e) => {
                        handleDataChange('cc', e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">
                    <TextField
                      fullWidth={true}
                      variant="outlined"
                      label="Subject:"
                      name="message-subject"
                      value={values.subject}
                      error={!!errors.subject}
                      helperText={errors.subject}
                      onChange={(e) => {
                        handleDataChange('subject', e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">
                    <TextField
                      fullWidth={true}
                      variant="outlined"
                      id="outlined-multiline-static"
                      label="Body:"
                      multiline
                      rows={7}
                      value={values.body}
                      error={!!errors.body}
                      helperText={errors.body}
                      onChange={(e) => {
                        handleDataChange('body', e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row" style={emailRowStyle}>
                  <div className="col">Attached Forms</div>
                  <div className="col" style={{ overflow: 'auto', height: '4em' }}>
                    {props.attachedForms.map((form) => (
                      <ul key={form.id}>{form.title}</ul>
                    ))}
                  </div>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                disabled={values.emails == undefined || values.emails == ''}
                className="btn btn-success"
                style={{ color: 'white' }}
                onClick={() => {
                  if (validate()) {
                    emailFormMutation.mutate({
                      FormFileName: '',
                      SenderEmailAddress: values.senderEmail,
                      FormName: '',
                      RecipientEmailAddress: values.emails,
                      MessageBody: values.body,
                      MessageSubject: values.subject,
                      Attachments: GetFormAttachments(),
                      CC: values.cc,
                    });
                  }
                }}
              >
                Email Form
              </Button>
              <Button
                className="btn btn-danger"
                style={{ color: 'white' }}
                onClick={HideEmailModal}
              >
                Cancel
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
